import {
  Directive,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
} from '@angular/core';

@Directive({
  selector: '[bsNoImageFound]',
  exportAs: 'bsNoImageFound',
})
export class NoImageFoundDirective implements OnChanges {
  @Input() bsNoImageFound?: string | null;
  @Input() src?: string | null;
  @HostBinding('src') imageSrc = '';
  hasError = false;
  readonly NO_IMAGE = 'assets/images/no-image.png';

  ngOnChanges(): void {
    this.hasError = !this.src?.trim();
    this.imageSrc = this.hasError ? this.fallback : this.src!;
  }

  private get fallback(): string {
    return this.bsNoImageFound?.trim() || this.NO_IMAGE;
  }

  @HostBinding('class.error') get error() {
    return this.hasError;
  }

  @HostListener('error')
  updateUrl() {
    if (this.hasError) return;
    this.hasError = true;
    this.imageSrc = this.fallback;
  }
}
